const RETRY_KEY = '@contenta-preload-retry';
const RETRY_COOLDOWN_MS = 60_000;
const IMPORT_ERROR =
  /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|Unable to preload CSS for/i;

// A reload can recover an old entry bundle after a deploy. Persist the attempt
// across documents so a blocked asset cannot create an automatic reload loop.
export function installPreloadRecovery(target = window) {
  let reloadScheduled = false;

  const recover = (event) => {
    if (reloadScheduled) {
      event.preventDefault();
      return;
    }
    if (target.navigator?.onLine === false) return;

    try {
      const now = Date.now();
      const previous = Number(target.sessionStorage.getItem(RETRY_KEY));
      if (previous && now >= previous && now - previous < RETRY_COOLDOWN_MS) {
        return;
      }
      target.sessionStorage.setItem(RETRY_KEY, String(now));
    } catch {
      // Without a persistent guard, reloading could loop. Let the original
      // error reach the existing error boundary/monitoring instead.
      return;
    }

    reloadScheduled = true;
    // Vite rethrows the original error unless this event is cancelled.
    event.preventDefault();
    target.location.reload();
  };

  const onRejection = (event) => {
    const message = event.reason?.message || event.reason;
    if (typeof message === 'string' && IMPORT_ERROR.test(message)) {
      recover(event);
    }
  };

  target.addEventListener('vite:preloadError', recover);
  target.addEventListener('unhandledrejection', onRejection);

  return () => {
    target.removeEventListener('vite:preloadError', recover);
    target.removeEventListener('unhandledrejection', onRejection);
  };
}
